/* eslint-disable no-shadow */
/* eslint-disable radix */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */

import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import CheckboxField from '../../../../../../primitives/form/CheckboxField/CheckboxField';
import SelectField from '../../../../../../primitives/form/SelectField/SelectField';
import TextField from '../../../../../../primitives/form/TextField/TextField';
import {
  setFieldValue,
  resetField,
  setOtherOptionValue,
  setOtherFieldLabel,
} from '../../../redux/actions/formTemplateActions';
import { validateAField } from '../../../utils/formTemplateValidation';
import InputFormatter from '../../InputFormatter/InputFormatter';
import AddAFieldOptions from './AddAFieldOptions/AddAFieldOptions';
import AddARadioOption from './AddARadioOption/AddARadioOption';

export function AddAFieldInput(props) {
  const {
    fieldValues,
    setFieldValue,
    setOtherOptionValue,
    setOtherFieldLabel,
    resetField,
    fieldAttributeName,
    validateAllFields,
    readOnly,
  } = props;

  const disabled = !fieldValues?.enabled;

  const [validateTitle, setValidateTitle] = useState({
    isError: false,
    errorMessage: '',
  });

  const getFieldValue = (event, attributeName, field) => {
    switch (attributeName) {
      case 'checkbox':
        return event.target.checked;
      case 'dropdown':
        return event;
      case 'input_format':
        return event;
      case 'option':
        return event;
      default:
        if (field === 'character_limit') {
          const numberValue = parseInt(event.target.value);
          const characterLimitMax = 50;
          const characterDefaultLimit = 8;
          if (numberValue < 1) {
            return (event.target.value = characterDefaultLimit);
          }
          if (Number.isNaN(numberValue)) {
            return (event.target.value = null);
          }
          if (event.target.value > characterLimitMax) {
            return (event.target.value = characterLimitMax);
          }

          return numberValue;
        }
        return event.target.value;
    }
  };

  const handleOnChange = (event, type, position, field) => {
    setFieldValue(position, field, getFieldValue(event, type, field));

    if (field === 'field_type') {
      resetField(position, event);
    }
  };

  const handleOtherOption = (value, position) => {
    setOtherOptionValue(position, value);
  };

  const handleOtherFieldLabel = (value, position) => {
    setOtherFieldLabel(position, value);
  };

  const handleTitleValidation = () => {
    return validateAField([{ fieldType: 'blankField', fieldValue: fieldValues.title }]);
  };

  const handleTitleOnBlur = () => {
    setValidateTitle(handleTitleValidation());
  };

  const handleOnClick = () => {
    setValidateTitle(false);
  };

  const handleCharacterLimitOnBlur = (fieldValue, position, fieldName) => {
    if (fieldValue === null) {
      setFieldValue(position, fieldName, 8);
    }
  };

  useEffect(() => {
    if (validateAllFields) {
      setValidateTitle(fieldAttributeName === 'title' ? handleTitleValidation() : false);
    }
  }, [validateAllFields]);

  switch (fieldAttributeName) {
    case 'title':
      return (
        <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
          <div className="form__group">
            <TextField
              showError={validateTitle.isError}
              errorMessage={validateTitle.errorMessage}
              fieldID={`${fieldValues.position}-title`}
              fieldIdentifier="field-name"
              fieldName="Field Name"
              fieldRequired
              value={fieldValues.title}
              handleClick={handleOnClick}
              handleChange={(event, type) => {
                handleOnChange(event, type, fieldValues.position, 'title');
              }}
              handleBlur={handleTitleOnBlur}
              disabled={readOnly || disabled}
              autoComplete="off"
            />
          </div>
        </div>
      );
    case 'field_type':
      return (
        <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
          <div className="form__group form__group--dropdown">
            <SelectField
              showError={false}
              errorMessage=""
              fieldID={`${fieldValues.position}-type`}
              fieldIdentifier="field-type"
              fieldName="Field type"
              fieldRequired
              disabled={readOnly || disabled}
              handleChange={(event, type) => {
                handleOnChange(event, type, fieldValues.position, 'field_type');
              }}
              options={{
                single_line: 'Single Line',
                descriptive: 'Descriptive',
                checkbox: 'Checkbox',
                radio: 'Radio',
                dropdown: 'Dropdown',
                date: 'Date',
              }}
              required
              value={fieldValues.field_type}
            />
          </div>
        </div>
      );
    case 'input_guidance':
      return (
        <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
          <div className="form__group">
            <TextField
              showError={false}
              errorMessage=""
              fieldID={`${fieldValues.position}-guidance`}
              fieldIdentifier="input-guidance"
              fieldName="Input guidance"
              fieldRequired={false}
              value={fieldValues.input_guidance}
              handleChange={(event, type) => {
                handleOnChange(event, type, fieldValues.position, 'input_guidance');
              }}
              disabled={readOnly || disabled}
              autoComplete="off"
            />
          </div>
        </div>
      );
    case 'required':
      return (
        <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
          <div className="form__group">
            <CheckboxField
              showError={false}
              errorMessage=""
              fieldID={`${fieldValues.position}-required`}
              fieldIdentifier="required"
              optionText="This field is required"
              fieldRequired={false}
              optionValue=""
              handleChange={(event, type) => {
                handleOnChange(event, type, fieldValues.position, 'required');
              }}
              disabled={readOnly || disabled}
              checked={fieldValues.validations.required}
            />
          </div>
        </div>
      );
    case 'character_limit':
      return (
        fieldValues.validations.character_restriction && (
          <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
            <div className="form__group">
              <TextField
                showError={false}
                errorMessage=""
                fieldID={`${fieldValues.position}-character-limit`}
                fieldIdentifier="character-limit"
                fieldName="Character limit"
                fieldRequired={false}
                value={fieldValues.validations.character_limit || ''}
                handleChange={(event, type) => {
                  handleOnChange(event, type, fieldValues.position, 'character_limit');
                }}
                disabled={readOnly || disabled}
                handleBlur={() =>
                  handleCharacterLimitOnBlur(
                    fieldValues.validations.character_limit,
                    fieldValues.position,
                    'character_limit',
                  )
                }
                autoComplete="off"
                numberOnly
                numberMinimum={1}
              />
            </div>
          </div>
        )
      );
    case 'input_format':
      return (
        <InputFormatter
          character_limit={fieldValues.validations.character_limit}
          character_restriction={fieldValues.validations.character_restriction}
          fieldID={`${fieldValues.position}-input-format`}
          input_format={fieldValues.validations.input_format}
          handleChange={(event, type) => {
            handleOnChange(event, type, fieldValues.position, 'input_format');
          }}
          readOnly={readOnly || disabled}
        />
      );
    case 'character_restriction':
      return (
        <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
          <div className="form__group form__group--dropdown">
            <SelectField
              showError={false}
              errorMessage=""
              fieldID={`${fieldValues.position}-character-restriction`}
              fieldIdentifier="validation"
              fieldName="Validation"
              fieldRequired={false}
              disabled={readOnly || disabled}
              handleChange={(event, type) => {
                const { character_limit: characterLimit } = fieldValues.validations;
                const defaultCharacterLimit = 8;
                if (characterLimit && event === '') {
                  setFieldValue(fieldValues.position, 'character_limit', null);
                } else if (!characterLimit && event !== '') {
                  setFieldValue(fieldValues.position, 'character_limit', defaultCharacterLimit);
                }
                handleOnChange(event === '' ? null : event, type, fieldValues.position, 'character_restriction');
              }}
              options={{
                '': 'No validation',
                'letters_and_numbers': 'Letters and Numbers',
                'letters': 'Letters only',
                'numbers': 'Numbers only',
              }}
              required
              value={
                fieldValues.validations.character_restriction === null
                  ? ''
                  : fieldValues.validations.character_restriction
              }
            />
          </div>
        </div>
      );
    case 'options':
      if (fieldValues.field_type === 'checkbox' || fieldValues.field_type === 'dropdown') {
        return (
          <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
            <div className="form__group">
              <AddAFieldOptions
                options={readOnly ? fieldValues.options : [...fieldValues.options, '']}
                handleChange={(event, type) => {
                  handleOnChange(event, type, fieldValues.position, 'options');
                }}
                fieldPosition={fieldValues.position}
                validateAllFields={validateAllFields}
                readOnly={readOnly || disabled}
              />
            </div>
          </div>
        );
      }
      if (fieldValues.field_type === 'radio') {
        return (
          <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
            <div className="form__group">
              <AddARadioOption
                options={readOnly ? fieldValues.options : [...fieldValues.options, '']}
                handleChange={(event, type) => {
                  handleOnChange(event, type, fieldValues.position, 'options');
                }}
                fieldPosition={fieldValues.position}
                validateAllFields={validateAllFields}
                readOnly={readOnly || disabled}
                handleOtherOption={(val) => {
                  handleOtherOption(val, fieldValues.position);
                }}
                handleOtherFieldLabel={(val) => {
                  handleOtherFieldLabel(val, fieldValues.position);
                }}
                hasOtherEnabled={fieldValues.other_enabled}
                otherFieldLabel={fieldValues.other_field}
              />
            </div>
          </div>
        );
      }
      break;
    case 'date_restriction':
      return (
        <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
          <div className="form__group form__group--dropdown">
            <SelectField
              showError={false}
              errorMessage=""
              fieldID={`${fieldValues.position}-character-restriction`}
              fieldIdentifier="validation"
              fieldName="Validation"
              fieldRequired={false}
              disabled={readOnly || disabled}
              handleChange={(event, type) => {
                handleOnChange(event, type, fieldValues.position, 'date_restriction');
              }}
              options={{
                '': 'None',
                'not_past_date': 'Cannot be in the past',
                'not_future_date': 'Cannot be in the future',
              }}
              required
              value={fieldValues.validations.date_restriction}
            />
          </div>
        </div>
      );
    default:
      return <div />;
  }
}

const mapStateToProps = (state) => {
  return {
    formTemplateVersion: state.formTemplateReducer.formTemplateVersion,
    readOnly: state.formTemplateUIReducer.readOnly,
  };
};

const mapDispatchToProps = {
  setFieldValue,
  setOtherOptionValue,
  setOtherFieldLabel,
  resetField,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAFieldInput);

AddAFieldInput.propTypes = {
  fieldValues: PropTypes.shape({
    position: PropTypes.number,
    title: PropTypes.string,
    field_type: PropTypes.string,
    input_guidance: PropTypes.string,
    required: PropTypes.bool,
    validations: PropTypes.shape({
      character_limit: PropTypes.number,
      character_restriction: PropTypes.string,
      input_format: PropTypes.string,
      date_restriction: PropTypes.string,
      required: PropTypes.bool,
    }),
    options: PropTypes.arrayOf(PropTypes.string),
    other_enabled: PropTypes.bool,
    other_field: PropTypes.string,
    enabled: PropTypes.bool,
  }),
  setFieldValue: PropTypes.func,
  setOtherOptionValue: PropTypes.func,
  setOtherFieldLabel: PropTypes.func,
  resetField: PropTypes.func,
  fieldAttributeName: PropTypes.string,
  validateAllFields: PropTypes.bool,
  readOnly: PropTypes.bool,
};
